import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomDataColumn } from '../../models/custom-viewer-config';
import { CustomUserPreferencesService } from '../../services/custom-user-preferences-service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { AldenService } from '../../services/alden.service';
import { AppStore, SnackbarErrorAction, SnackbarInfoAction } from '@alfresco/aca-shared/store';
import { Store } from '@ngrx/store';
import { KeyValue } from '@angular/common';
import { CustomListQueryBuilderService } from '../../services/custom-list-query-builder.service';
interface ConfigDialogData {
    columns: CustomDataColumn[];
    viewer: string;
    files: KeyValue<string, string>[];
}

@Component({
    selector: 'smt-config-dialog',
    templateUrl: './config.dialog.html',
    styleUrls: ['./config.dialog.scss']
})
export class SMTConfigDialogComponent {
    columns: CustomDataColumn[];
    defaultConfigID: string;
    viewer: string;
    isDragging: boolean = false;
    title: string = "";
    files: KeyValue<string, string>[] = [];

    defaultSearchId: string = "";

    constructor(
        private dialogRef: MatDialogRef<SMTConfigDialogComponent>,
        private customUserPreferencesService: CustomUserPreferencesService,
        private customListQueryBuilderService: CustomListQueryBuilderService,
        private aldenService: AldenService,
        private store: Store<AppStore>,
        @Inject(MAT_DIALOG_DATA) data: ConfigDialogData
    ) {
        console.log(data.columns)
        this.columns = data.columns;
        this.viewer = data.viewer;
        this.defaultConfigID = this.customUserPreferencesService.getDefaultConfig();
        this.files = data.files
        this.defaultSearchId = this.customUserPreferencesService.getDefaultSearch();
    }

    saveConfiguration(): void {
        console.log(this.columns);
        const postBody = {
            viewer: this.viewer,
            content: JSON.stringify(this.columns)
        }
        this.customUserPreferencesService.saveViewerConfigForUser(postBody).then(res => {
            if (res) {
                this.dialogRef.close();
                this.store.dispatch(new SnackbarInfoAction('ALDEN.DIALOGS.SAVE_VIEWER_CONFIG.SUCCESS'));
                this.customUserPreferencesService.setDefaultColumns(this.columns);
            }
        });
    }

    deleteConfiguration(): void {
        this.aldenService.deleteNodeFromID(this.defaultConfigID).then(res => {
            if (res) {
                this.customUserPreferencesService.unsetDefaultConfig();
                this.store.dispatch(new SnackbarInfoAction('ALDEN.DIALOGS.SAVE_VIEWER_CONFIG.DELETED'));
            }
        });
    }

    toggleIsHidden(column: CustomDataColumn) {
        column.isHidden = !column.isHidden;
    }

    dropColumn(event: CdkDragDrop<CustomDataColumn[]>): void {
        moveItemInArray(this.columns, event.previousIndex, event.currentIndex);

        this.columns.forEach((column, index) => column.order = index + 1);
    }

    dragStarted() {
        this.isDragging = true;
    }

    dragEnded() {
        this.isDragging = false;
    }


    async saveSearch() {
        const JSONtext = this.customUserPreferencesService.getCurrentSearchValues();
        const request = {
            viewer: this.viewer,
            title: this.title,
            content: JSONtext
        }

        this.customUserPreferencesService.uploadSavedSearch(request)
            .then(res => {
                const jsonRes = JSON.parse(res);
                this.files?.push({ key: jsonRes.key, value: jsonRes.value });
                this.store.dispatch(new SnackbarInfoAction('ALDEN.DIALOGS.SAVE_SEARCH.MESSAGES.CREATED'));
            })
            .catch(() =>
                this.store.dispatch(new SnackbarErrorAction('ALDEN.MESSAGES.ERRORS.NO_HOMEFOLDER'))
            );

        this.title = "";
    }

    async loadSearch(selectedFile: KeyValue<string, string>, event: MouseEvent) {
        event.stopPropagation();
        this.dialogRef.close();
        const file = await this.aldenService.getContentOfFile(selectedFile.key);
        const jsonContent = JSON.parse(await file.text());
        this.customListQueryBuilderService.clearAndSetDefaultFilterQueries();
        this.customUserPreferencesService.setSelectedSearch(jsonContent);
    }

    async deleteFile(file: KeyValue<string, string>, event: MouseEvent): Promise<void> {
        event.stopPropagation();

        this.aldenService.deleteNodeFromID(file.key).then((res) => {
            if (res) {
                this.files = this.files?.filter(f => f.key !== file.key);
            }
        });
    }

    toggleDefaultSearch(file: KeyValue<string, string>, event: MouseEvent) {
        event.stopPropagation();
        let message;

        if (this.defaultSearchId === file.key) {
            this.defaultSearchId = "";
            message = 'ALDEN.DIALOGS.SAVE_SEARCH.MESSAGES.UNSET_DEFAULT';
        } else {
            this.defaultSearchId = file.key;
            message = 'ALDEN.DIALOGS.SAVE_SEARCH.MESSAGES.SET_DEFAULT'
        }

        this.customUserPreferencesService.setDefaultSearch(this.defaultSearchId);
        this.store.dispatch(new SnackbarInfoAction(message));
    }
}